import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a ResizeObserver error
    if (error.message && error.message.includes('ResizeObserver')) {
      // Don't update state for ResizeObserver errors, just suppress them
      return null;
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Check if it's a ResizeObserver error
    if (error.message && error.message.includes('ResizeObserver')) {
      // Suppress ResizeObserver errors
      console.warn('ResizeObserver error suppressed:', error.message);
      return;
    }
    
    // Log other errors
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="alert alert-danger">
          <h4>Something went wrong.</h4>
          <p>Please refresh the page and try again.</p>
          <button 
            className="btn btn-primary" 
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
